import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faLink } from "@fortawesome/free-solid-svg-icons";

import "./styles/project.css";

const Project = (props) => {
	const { title, summary, description, tools, linkText, link, demoText, demoLink } = props;
	const [isFlipped, setIsFlipped] = useState(false);

	return (
		<div className="project">
			<div
				className={`project-container ${isFlipped ? "is-flipped" : ""}`}
				role="button"
				tabIndex={0}
				onClick={() => setIsFlipped((current) => !current)}
				onKeyDown={(event) => {
					if (event.key === "Enter" || event.key === " ") {
						event.preventDefault();
						setIsFlipped((current) => !current);
					}
				}}
				aria-pressed={isFlipped}
				aria-label={`${isFlipped ? "Show summary for" : "Show highlights for"} ${title}`}
			>
				<div className="project-card-face project-card-front">
					<div className="project-title">{title}</div>
					<div className="project-summary">{summary}</div>
					<div className="project-links">
						<a
							href={link}
							target="_blank"
							rel="noreferrer"
							onClick={(event) => event.stopPropagation()}
						>
							<div className="project-link">
								<FontAwesomeIcon icon={faLink} />
								<div className="project-link-text">{linkText}</div>
							</div>
						</a>
						{demoLink && (
							<a
								href={demoLink}
								target="_blank"
								rel="noreferrer"
								onClick={(event) => event.stopPropagation()}
							>
								<div className="project-link">
									<FontAwesomeIcon icon={faLink} />
									<div className="project-link-text">{demoText}</div>
								</div>
							</a>
						)}
					</div>
					<div className="project-flip-hint">Click for highlights</div>
				</div>
				<div className="project-card-face project-card-back">
					<div className="project-description">{description}</div>
					<div className="tool-stack" aria-label={`Tools used for ${title}`}>
						<div className="tool-stack-label">Tools & focus</div>
						<div className="tool-tags">
							{tools.map((tool) => (
								<span className="tool-tag" key={tool}>{tool}</span>
							))}
						</div>
					</div>
					<div className="project-flip-hint">Click to return</div>
				</div>
			</div>
		</div>
	);
};

export default Project;
